var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5524 27L18.5596 17.0072C21.4263 13.3701 21.1833 8.06609 17.8295 4.71231C14.213 1.0959 8.32863 1.0959 4.71228 4.71231C1.09594 8.32871 1.09588 14.2132 4.71228 17.8295C8.06115 21.1784 13.3637 21.4313 17.0072 18.5596L26.9476 28.5C27.3762 28.9287 28.0713 28.9288 28.5 28.5C28.9286 28.0713 28.981 27.4287 28.5524 27ZM16.2771 16.2771C13.5166 19.0377 9.02507 19.0376 6.26467 16.2771C3.50426 13.5167 3.50426 9.0251 6.26467 6.26469C9.02507 3.50434 13.5166 3.50422 16.2771 6.26469C19.0375 9.02516 19.0375 13.5167 16.2771 16.2771Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.5e1555e1eb0bd7931b89182b84b1cd42.svg";
export { ForwardRef as ReactComponent };